import styled from "styled-components";

export const SideMenuItemsListDefaultBox = styled.div`
    border-radius: 5px;
    background-color: ${({theme}) => theme.colors.background};
    margin: 1rem 0 0 0;
    padding: 0;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        margin: 1rem 0 0 0;
    }
`;
